import axios from 'axios';
import { HttpQuery } from '../types/http';
import { CoSignerRequest } from '../types/coSignerRequests';
import { DealApplicantInfo } from '../types/applicants';

export const getCoSignerRequestsAndApplicantInfo = (
  query?: HttpQuery
): (() => Promise<{
  coSignerRequests: CoSignerRequest[];
  applicantInfo: DealApplicantInfo;
  names: string;
}>) => {
  return async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/co_signer_request/`,
      {
        headers: {
          query:
            query && Object.keys(query)?.length
              ? JSON.stringify(query)
              : undefined,
        },
      }
    );
    return {
      coSignerRequests: response.data.result.coSignerRequests,
      applicantInfo: response.data.result.applicantInfo,
      names: response.data.result.names,
    };
  };
};
export const createCoSignerRequest = (): ((request: {
  applicantInfo: DealApplicantInfo;
  coSignerRequestId?: string;
  dealId: string;
  token: string | null;
}) => Promise<CoSignerRequest>) => {
  return async (request) => {
    const { token, ...restRequest } = request;
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/co_signer_request/`,
      restRequest,
      {
        headers: {
          Captcha: token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data.result;
  };
};
